/* Version: 3.5.137 */
'use client';
import styled from 'styled-components';
import { IconWrapper as IconWrapper$1, InputWrapper, InputValue } from '../Select/styledComponents.js';
import { INPUT_VARIANT } from '../TextInput/constants.js';
import { DROPDOWN_VARIANT } from './constants.js';

var IconWrapper = /*#__PURE__*/styled(IconWrapper$1).withConfig({
  displayName: "styledComponents__IconWrapper",
  componentId: "sc-1d3l53r-0"
})(["padding:0 0.75rem;pointer-events:none;position:absolute;right:0;", "[data-variant='", "'] &,", "[data-variant='", "'] &{padding:0 0 0 1.5rem;}"], InputWrapper, INPUT_VARIANT.BASIC_LINE, InputWrapper, DROPDOWN_VARIANT.BASIC_LINE_DASHED);
process.env.NODE_ENV !== "production" ? IconWrapper.displayName = 'IconWrapper' : undefined;
var DropdownInput = /*#__PURE__*/styled(InputValue).withConfig({
  displayName: "styledComponents__DropdownInput",
  componentId: "sc-1d3l53r-1"
})(["appearance:none;cursor:pointer;&::-ms-expand{display:none;}", ""], function (_ref) {
  var dropdownInputStyle = _ref.dropdownInputStyle;
  return dropdownInputStyle;
});
process.env.NODE_ENV !== "production" ? DropdownInput.displayName = 'DropdownInput' : undefined;

export { DropdownInput, IconWrapper };
